module.exports = __webpack_public_path__ + "assets/img/media_20.98619256.png";